import React from 'react';
import { VerificationStatusProps } from '../../types/VerificationTypes';
import { CheckCircle, AlertCircle } from 'lucide-react';

const VerificationStatus: React.FC<VerificationStatusProps> = ({ 
  verified, 
  verificationId, 
  schemaName 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 md:p-6 mb-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
        <div className="flex items-center space-x-4">
          {verified ? (
            <div className="flex items-center space-x-2">
              <CheckCircle className="h-6 w-6 md:h-8 md:w-8 text-verified-green" />
              <div>
                <h1 className="text-xl md:text-2xl font-bold text-verified-green">VERIFIED</h1>
                <p className="text-xs md:text-sm text-warm-slate">Credential verification successful</p>
              </div>
            </div>
          ) : (
            <div className="flex items-center space-x-2">
              <AlertCircle className="h-6 w-6 md:h-8 md:w-8 text-red-500" />
              <div>
                <h1 className="text-xl md:text-2xl font-bold text-red-600">VERIFICATION FAILED</h1>
                <p className="text-xs md:text-sm text-warm-slate">Credential could not be verified</p>
              </div>
            </div>
          )}
        </div>
        
        <div className="text-left md:text-right">
          {/* Commented out Verification ID and Schema display */}
          {/* <p className="text-xs md:text-sm text-warm-slate">Verification ID</p>
          <p className="font-mono text-xs md:text-sm text-charcoal-ink break-all">{verificationId}</p>
          <p className="text-xs md:text-sm text-warm-slate mt-1">Schema</p>
          <p className="text-xs md:text-sm text-charcoal-ink break-all">{schemaName}</p> */}
          
          {/* Education Category Badge */}
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-white border border-gray-300">
            <span className="text-xs font-medium text-gray-700">Education</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationStatus; 